// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TranslateFn = (key: string, options?: any) => string;

export const getScheduleLabel = (increaseNum: number | null | undefined, scheduleType: number | null | undefined, t: TranslateFn): string => {
  if (!increaseNum || !scheduleType) return '—';

  const count = parseInt(String(increaseNum), 10);
  if (Number.isNaN(count) || count === 0) return '—';

  const unitKey = {
    3: 'days',
    4: 'weeks',
    5: 'months',
    6: 'years',
  }[scheduleType];

  if (!unitKey) return '—';

  return t(`dashboard:autojobs.intervalUnits.${unitKey}`, { count });
};

export const getScheduleTypeLabel = (scheduleType: number | null | undefined, t: TranslateFn): string => {
  if (scheduleType == null) return '—';

  const key = {
    0: 'once',
    1: 'minute',
    2: 'hourly',
    3: 'daily',
    4: 'weekly',
    5: 'monthly',
    6: 'yearly',
  }[scheduleType];

  if (!key) return '—';

  return t(`settings:autojobs.scheduleTypes.${key}`);
};

export const getTriggerLabel = (triggerRaw: string | null | undefined, t: TranslateFn): string => {
  if (!triggerRaw) return '—';

  const [amountStr, unitKey, sourceKey] = triggerRaw.split('|');
  const amount = parseInt(amountStr || '0', 10);

  if (Number.isNaN(amount) || !unitKey || !sourceKey) return '—';

  const unitTranslationKey = {
    d: 'days',
    m: 'months',
    y: 'years',
  }[unitKey];

  const sourceTranslationKey = {
    memberExpireDate: 'memberExpireDate',
    invoiceExpireDate: 'invoiceExpireDate',
    createDate: 'createDate',
    resDate: 'resignationDate',
  }[sourceKey];

  if (!unitTranslationKey || !sourceTranslationKey) return '—';

  return t('dashboard:autojobs.triggerLabel', {
    count: amount,
    unit: t(`dashboard:autojobs.units.${unitTranslationKey}`, { count: amount }),
    source: t(`dashboard:autojobs.sources.${sourceTranslationKey}`),
  });
};
